function initProductSlider(sectionId) {
  var section = document.querySelector('[data-section-id="' + sectionId + '"]');
  if (!section) return;

  var stage = section.querySelector('[data-slider]');
  if (!stage) return;

  var count = parseInt(stage.dataset.count, 10);
  if (count < 2) return;

  var contents = stage.querySelectorAll('[data-content]');
  var labels = stage.querySelectorAll('[data-label]');
  var current = 0;

  var titleSwiper = new Swiper(stage.querySelector('.js-title-slider'), {
    loop: true,
    speed: 500,
    allowTouchMove: false,
    slidesPerView: 1,
  });

  function resetAnim(el) {
    if (!el) return;
    el.style.animation = 'none';
    void el.offsetWidth;
    el.style.animation = '';
  }

  function syncLeft(index) {
    if (index === current) return;

    var prev = current;
    current = index;

    labels[prev].classList.remove('is-active');
    labels[current].classList.add('is-active');

    titleSwiper.slideToLoop(current, 500);
    setTimeout(function() {
      var titleEl = titleSwiper.slides[titleSwiper.activeIndex].querySelector('.aqualogic-product-slider__title');
      resetAnim(titleEl);
    }, 10);

    contents[prev].classList.remove('is-active');
    contents[current].classList.add('is-active');
  }

  // Trigger initial title animation
  setTimeout(function() {
    var titleEl = titleSwiper.slides[titleSwiper.activeIndex].querySelector('.aqualogic-product-slider__title');
    resetAnim(titleEl);
  }, 10);

  var imageSwiper = new Swiper(stage.querySelector('.js-product-slider'), {
    loop: true,
    speed: 500,
    pagination: {
      el: stage.querySelector('.js-product-slider-pagination'),
      clickable: true,
    },
    on: {
      slideChange: function() {
        syncLeft(this.realIndex);
      }
    }
  });

  stage.addEventListener('click', function(e) {
    if (e.target.closest('.js-slider-prev')) {
      imageSwiper.slidePrev();
    }
    if (e.target.closest('.js-slider-next')) {
      imageSwiper.slideNext();
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-product-slider-id]').forEach(function(el) {
    initProductSlider(el.dataset.productSliderId);
  });
});
